import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, viewChild } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { ControlPoint } from '../../bo/controlPoint';
import { Site } from '../../bo/site';
import { FonctionsService } from '../../services/fonctions-partagees.service';

@Component({
  selector: 'app-site-control-points-modale',
  templateUrl: './site-control-points-modale.component.html',
  styleUrls: ['./site-control-points-modale.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteControlPointsModaleComponent implements OnInit {
  readonly modalConfirmCancel = viewChild<ModalDirective>('modalConfirmCancel');
  readonly modalConfirmSuppr = viewChild<ModalDirective>('modalConfirmSuppr');
  modaleFermee = new EventEmitter<boolean>();

  listControlPoint: ControlPoint[];
  controlPoint: ControlPoint;
  controlPointModif: ControlPoint;
  site: Site;
  epsgSelectionne: string;
  epsgModif = false;
  coordInvalide = false;

  success = false;
  erreurApi: boolean;
  erreurCoord: boolean;
  erreurControlPointNumber: boolean;
  erreurControlPointName: boolean;

  constructor(public bsModalRef: BsModalRef, private readonly http: HttpService, public fonctionsService: FonctionsService) { }

  ngOnInit() {
    if (null !== this.controlPoint) {
      this.controlPointModif = JSON.parse(JSON.stringify(this.controlPoint));
    }
    else {
      this.controlPointModif = new ControlPoint();
      this.controlPointModif.siteId = this.site.siteId;
    }
  }

  delete() {
    this.fonctionsService.loading_screen(true);
    this.http.delete('Sites/' + this.site.siteId + '/ControlPoint/' + this.controlPoint.controlPointId).subscribe(() => {
      this.fonctionsService.loading_screen(false);
      this.success = true;
      this.hideConfirmSuppr();
      this.bsModalRef.hide();
      this.modaleFermee.emit(true);
    }, () => {
      this.erreurApi = true;
      this.fonctionsService.loading_screen(false);
      this.hideConfirmSuppr();
    });
  }

  showConfirmSuppr() {
    this.modalConfirmSuppr()?.show();
  }

  hideConfirmSuppr() {
    this.modalConfirmSuppr()?.hide();
  }

  showModalCancel() {
    if (this.diff()) {
      this.modalConfirmCancel()?.show();
    }
    else
      this.bsModalRef.hide();
  }

  hideModalCancel() {
    this.modalConfirmCancel()?.hide();
  }

  protected checkControlPointName(){
    if(this.controlPointModif.name != undefined){
      this.erreurControlPointName = false;
    }
  }

  protected checkControlPointNumber(){
    if(this.controlPointModif.numeroPoint != undefined){
      this.erreurControlPointNumber = false;
    }
  }

  onSubmit() {
    if(this.controlPointModif.name == undefined || this.controlPointModif.name == '' ){
      this.erreurControlPointName = true;
      return;
    }
    if(this.controlPointModif.numeroPoint == undefined){
      this.erreurControlPointNumber = true;
      return;
    }
  


    this.fonctionsService.loading_screen(true);
    var request: Observable<ControlPoint>;
    if (!this.epsgModif) this.epsgSelectionne = this.site.epsg;
    try {
      this.controlPointModif.x = +this.controlPointModif.x.toString().replace(/,/, '.');
      this.controlPointModif.y = +this.controlPointModif.y.toString().replace(/,/, '.');
      this.controlPointModif.z = +this.controlPointModif.z.toString().replace(/,/, '.');
    } catch (error) {
      this.fonctionsService.loading_screen(false);
    }

    if (!this.coordInvalide) {
      if (this.diff()) {
        request = this.http.put<ControlPoint, ControlPoint>('Sites/' + this.site.siteId + '/ControlPoint/' + this.epsgSelectionne, this.controlPointModif);
      }
      else {
        request = this.http.post<ControlPoint, ControlPoint>('Sites/' + this.site.siteId + '/ControlPoint/' + this.epsgSelectionne, this.controlPointModif);
      }
      request.subscribe(result => {
        if (result) {
          this.success = true;
        }
        else
          this.erreurApi = true;

        this.fonctionsService.loading_screen(false);
        this.bsModalRef.hide();
        this.modaleFermee.emit(true);
      },(error) => {
          if (error.status == 400) this.erreurCoord = true;

          this.fonctionsService.loading_screen(false);
      },() => {
          this.fonctionsService.loading_screen(false);
        });
    } else {
      this.fonctionsService.loading_screen(false);
    }
  }

  private diff(): Boolean {
    if (null !== this.controlPoint && (
      this.controlPointModif.name !== this.controlPoint.name
      || this.controlPointModif.numeroPoint !== this.controlPoint.numeroPoint
      || this.epsgModif
      || this.controlPointModif.x !== this.controlPoint.x
      || this.controlPointModif.y !== this.controlPoint.y
      || this.controlPointModif.z !== this.controlPoint.z
      || this.controlPointModif.alpha !== this.controlPoint.alpha
      || this.controlPointModif.k !== this.controlPoint.k
      || this.controlPointModif.ppv !== this.controlPoint.ppv
      || this.controlPointModif.isActif !== this.controlPoint.isActif
      )) {
      return true;
    }
    return false;
  }

  getEPSG(epsg: string) {
    this.epsgSelectionne = epsg;
  }

  isModifEPSG(isModif: boolean) {
    this.epsgModif = isModif;
  }

  getCoordX(coord) {
    this.controlPointModif.x = coord;
  }

  getCoordY(coord) {
    this.controlPointModif.y = coord;
  }

  getCoordZ(coord) {
    this.controlPointModif.z = coord;
  }

  getCoordInvalide(event) {
    this.coordInvalide = event;
  }
}
